import * as React from 'react';
import Helmet from 'react-helmet';

const CarouselStyles: React.FC = () => {
	return (
		<Helmet>
			<link
				rel="stylesheet"
				type="text/css"
				href="https://cdn.websky.aero/content/frontend/common/libs/slick-carousel/1.6.0/slick.min.css"
			/>

			<link
				rel="stylesheet"
				type="text/css"
				href="https://cdn.websky.aero/content/frontend/common/libs/slick-carousel/1.6.0/slick-theme.min.css"
			/>
		</Helmet>
	);
};

export default CarouselStyles;
